export type QuakeFilter = { status: string; page: number; pageSize: number }
export type EventFilter = { type?: string; status: string; page?: number; pageSize?: number }
export type TriggerFilter = { eventId?: string; page?: number; pageSize?: number }
export type IncidentFilter = { type?: string; status: string; page: number; pageSize: number }
export type ReportFilter = { page: number; pageSize: number }
export type AuditFilter = { actorId?: string; action?: string; regionCode?: string; page: number; pageSize: number }
export type VolunteerFilter = { regionCode?: string; status?: string; page: number; pageSize: number }
export type TaskFilter = { regionCode?: string; status?: string; volunteerId?: string; page: number; pageSize: number }
export type UserFilter = { regionCode?: string; page: number; pageSize: number }

export const qk = {
  stats: ['stats', 'realtime'] as const,
  recentQuakes: (limit = 20) => ['earthquakes', 'recent', limit] as const,
  earthquakes: (f: QuakeFilter) => ['earthquakes', 'list', f] as const,
  earthquake: (id: string) => ['earthquakes', 'detail', id] as const,
  triggers: (f: TriggerFilter) => ['triggers', f] as const,
  devices: ['devices', 'online'] as const,
  deviceDist: ['devices', 'distribution'] as const,
  events: (f: EventFilter) => ['events', 'list', f] as const,
  event: (id: string) => ['events', 'detail', id] as const,
  incidents: (f: IncidentFilter) => ['incidents', f] as const,
  reports: (f: ReportFilter) => ['reports', f] as const,
  report: (id: string) => ['reports', 'detail', id] as const,
  me: ['v2', 'me'] as const,
  rescueFlow: (eventId: string) => ['v2', 'rescue-flow', eventId] as const,
  admin: {
    users: (f: UserFilter) => ['v2', 'users', f] as const,
    roles: ['v2', 'roles'] as const,
    permissions: ['v2', 'permissions'] as const,
    audit: (f: AuditFilter) => ['v2', 'audit', f] as const,
    volunteers: (f: VolunteerFilter) => ['v2', 'volunteers', f] as const,
    tasks: (f: TaskFilter) => ['v2', 'tasks', f] as const,
    certificates: ['v2', 'certificates'] as const,
    agreement: ['v2', 'agreement'] as const,
  },
}
